import { UPDATE_STATIC_COUPON, UPDATE_STATIC_COUPON_SUCCESS, UPDATE_STATIC_COUPON_ERROR, UPDATE_STATIC_COUPON_EMPTY } from './../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateStaticCoupon = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STATIC_COUPON:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_STATIC_COUPON_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_STATIC_COUPON_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action?.payload,
      };
      break;

    case UPDATE_STATIC_COUPON_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateStaticCoupon;
